import { TrackId } from "@signal-app/core"
import { atom, useAtomValue, useSetAtom } from "jotai"
import { useCallback } from "react"
import { useSong } from "./useSong"

export function useTrackList() {
  const { tracks, getTrack, moveTrack } = useSong()
  const trackIds = tracks
    .filter((track) => !track.isConductorTrack)
    .map((track) => track.id)

  return {
    get isOpen() {
      return useAtomValue(isOpenAtom)
    },
    setOpen: useSetAtom(isOpenAtom),
    trackIds,
    moveTrack: useCallback(
      (id: TrackId, overId: TrackId) => {
        const track = getTrack(id)
        const overTrack = getTrack(overId)
        if (track === undefined || overTrack === undefined) {
          return
        }
        const fromIndex = tracks.indexOf(track)
        const toIndex = tracks.indexOf(overTrack)
        moveTrack(fromIndex, toIndex)
      },
      [tracks, getTrack, moveTrack],
    ),
  }
}

// atoms
const isOpenAtom = atom(false)
